<template>
    <v-col class="notice-body">
        <div class="relative">
            <TTextArea rows="6" :key="notice._id" v-model="noticeBody" @pasteFile="val => addFile(val)"/>
            <InputFileButton ref="select_file" class="select-file" accept="image/*" @change="addFile"/>
        </div>
        <Images class="ml-5" :images="imagesForNotice" @deleteImage="val  => deleteFile(val)"/>
    </v-col>
</template>

<script>
    import { mapActions, mapGetters} from 'vuex'
    import { debounce } from 'lodash'
    import TTextArea from '../misc/TTextArea';
    import InputFileButton from '@/components/misc/InputFileButton.vue';
    import Images from './../popups/Images';
    import { imagesOfItems } from '../../helpers';
    export default {
        name: 'NoticeBody',
        props: ['notice'],
        components: {
            TTextArea,
            InputFileButton,
            Images
        },
        data() {
            return {
            
            }
        },
        computed:{
            ...mapGetters(['feeds']),
            noticeBody:{
                get(val){
                    return this.notice.body
                },
                set: debounce(function(newVal) {
                    this.editNotice({feed_id: this.feeds[0]._id, notice_id: this.notice._id, text: newVal})
                }, 450)
            },
            regexpForNotice() {
                if(!this.notice.body) return []
                const regexp = /(\(.*?)?\b((?:https?|ftp|file):\/\/[-a-z0-9+&@#\/%?=~_()|!:,.;]*[-a-z0-9+&@#\/%=~_()|])/ig
                const links = this.notice.body.match(regexp)
                if (links) {
                    const regexpLinks = new RegExp('http(?::\\/\\/|s:\\/\\/).*?\\.(?:gif|jpg|jpeg|png)', 'i')
                    const filteredLinks = [...links.map(el => el.split('"').join(''))].filter(el =>  el.match(regexpLinks))
                    return filteredLinks.map(el => el.replace(new RegExp("amp;", 'g'), "")) 
                } else return []
            },
            imagesForNotice() {
                const set = this.regexpForNotice && [...(this.notice.blockedLinks || [])] && new Set(this.notice.blockedLinks)
                const links = this.regexpForNotice.filter(e => !set.has(e))
                const noticeImages = this.notice.images && this.notice.images.map((el) => this.$root.origin + '/api' + el)
                return [...(noticeImages || []), ...links]
            }
        },
        methods:{
            ...mapActions(['editNotice', 'uploadFiles', 'setImagesToNotice', 'setBlockedLinksToNotice']),
            async addFile(e) {
                const file = (e.target && e.target.files[0]) || e
                if (file) {                    
                    const formData = new FormData()
                    formData.append('file', file)
                    const filesRes = await this.uploadFiles(formData)
                    await this.setImagesToNotice({feed_id: this.feeds[0]._id, notice_id: this.notice._id, images: [...(this.notice.images || []), ...filesRes.map((el) => el.path)]})
                }
            },
            async deleteFile(e) {
                if (e.includes(this.$root.origin + "/api")) {
                    this.notice.images.splice(this.notice.images.findIndex(image => image == e.slice(24)),1)
                    await this.setImagesToNotice({feed_id: this.feeds[0]._id, notice_id: this.notice._id, images: [...(this.notice.images || [])]})
                } else {
                    this.notice.blockedLinks.push(e)
                    await this.setBlockedLinksToNotice({feed_id: this.feeds[0]._id, notice_id: this.notice._id, blockedLinks: [...(this.notice.blockedLinks || [])]})
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.notice-body {
    background: white;
    height: auto;
    .select-file{
        position: absolute;
        bottom: 0;
        right: 20px;
    }
}
</style>